<aside class="sidebar" aria-label="Primary">
    <nav class="sidebar__links">
        <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
        <a routerLink="/upload" routerLinkActive="is-active">Upload</a>
    </nav>

    <div class="sidebar__footer">
        @if (displayName) {
        <p class="sidebar__user">{{ displayName }}</p>
        }
        <a class="sidebar__logout" routerLink="/logout">Logout</a>
    </div>
</aside>